import { Avatar } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { FormationLight, FormationSummary } from '@wwf/sdk';
import { useResource } from '@app/misc/useResource';

export interface FormationAvatarProps {
    record?: FormationLight | FormationSummary;
    width?: number;
    height?: number;
    title?: string;
    variant?: 'sm' | 'md' | 'lg' | 'xl';
    style?: React.CSSProperties;
}

const sizes = {
    sm: 30,
    md: 40,
    lg: 80,
    xl: 120,
} as const;

export const FormationAvatar = (props: FormationAvatarProps) => {
    const record = useRecordContext<FormationLight | FormationSummary>(props);
    const { data: src } = useResource(record?.cover?.id);

    const { width, height, variant = 'md', style, title } = props;

    const _width = width ?? sizes[variant];
    const _height = height ?? sizes[variant];

    return (
        <Avatar
            variant="rounded"
            sx={{ ...style, width: _width, height: _height, borderRadius: 2 }}
            title={title}
            src={src ?? undefined}
        >
            {src ? (
                <img src={src} alt={record?.name ?? ''} />
            ) : (
                (record?.name ?? '').charAt(0).toUpperCase()
            )}
        </Avatar>
    );
};
